import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

export type TuileButtonProps = {
  id?: number;
  title?: string;
  icon: string;
  iconFontFamily?: string;
  color?: string;
  status?: 'active' | 'inactive';
  onPress?: () => void;
};

@Component({
  selector: 'app-larged-tuile',
  templateUrl: './larged-tuile.component.html',
  styleUrls: ['./larged-tuile.component.scss'],
  standalone: true,
  imports: [IonButton, TranslatePipe],
})
export class LargedTuileComponent {
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() buttons: TuileButtonProps[] = [];
  @Input() selectItem: number = 0;

  @Input() mode: string | null = null;
  @Input() modeColor: string = '';
  @Input() status: string | null = null;

  @Input() statusMode: 'active' | 'inactive' | 'alarm' | null = null;
  @Input() disableBottom: boolean = false;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPressSetting = new EventEmitter<any>();

  constructor() {}

  goToSetting() {
    this.onPressSetting.emit();
  }

  clickOn(button: TuileButtonProps, index: number) {
    if (button.onPress) {
      button.onPress();
    }

    this.onChange.emit(index);
  }
}
